// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__3bW0+","filters_close":"FiltersBlock_filters_close__KsIQX"};